<template>
  <div>
    <!-- Overlay (when menu is open) -->
    <div
        v-if="isVisible"
        class="position-fixed w-100 h-100"
        style="top: 0; left: 0; background: rgba(0,0,0,0.5); z-index: 1061;"
        @click="closeSidebar"
    ></div>

    <!-- Sidebar Menu (slides in from left when open) -->
    <div
        class="position-fixed bg-white border-end"
        :style="{
          left: isVisible ? '0' : '-250px',
          width: '250px',
          top: '60px',
          height: 'calc(100vh - 60px)',
          zIndex: 1065,
          transition: 'left 0.3s ease-in-out',
          boxShadow: isVisible ? '2px 0 10px rgba(0,0,0,0.2)' : 'none'
        }"
    >
      <!-- Menu Content -->
      <div class="p-3 h-100 overflow-auto">
        <ul class="list-unstyled text-start w-100">
          <h2>Menu</h2>
          <li v-for="(group, index) in localReportGroups" :key="group.title">
            <div v-if="index === 0 && !group.title.length">
              <h5 class="fw-bold mb-3 border-bottom">
                <a class="link-dark text-decoration-none" :href="'/' + group.reports[0].id">
                  {{ group.reports[0].title }}
                </a>
              </h5>
            </div>
            <div v-else>
              <a class="link-dark text-decoration-none" href="#" @click="toggleGroup(index)">
                <h5 class="fw-bold">{{ group.title }}</h5>
              </a>
              <ul class="list-unstyled mb-1 ps-2 collapsed" :class="{ expanded: isExpanded(index) }">
                <li v-for="report in group.reports" :key="report.id" class="pb-2">
                  <a
                      :class="[
                      'link-dark text-decoration-none',
                      currentReportId === report.id ? 'fw-bold' : ''
                    ]"
                      :href="group.title === 'Finance'
                        ? '/finance/' + report.id
                        : (group.title === 'Analytics' || group.title === 'UTM Analytics')
                          ? '/analytics/' + report.id
                          : '/' + report.id"
                      @click="handleReportClick(report.id)"
                  >
                    {{ report.title }}
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li class="mt-4 pt-3 border-top">
            <a class="link-dark text-decoration-none" href="#" role="button" @click.prevent="doSignOut">
              <h5 class="fw-bold mb-0">Sign Out</h5>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ReportService from "@/services/report-service";
import AuthService from "@/services/auth-service";

export default defineComponent({
  name: 'Menu',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    reportId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      localReportGroups: [],
      expandedGroups: new Map(),
    }
  },
  computed: {
    currentReportId() {
      return this.reportId || '';
    },
  },
  created() {
    this.loadReportGroups();
  },
  methods: {
    closeSidebar() {
      this.$emit('close');
    },
    doSignOut() {
      this.closeSidebar();
      AuthService.signOut().then(() => {
        this.$router.push('/signin');
      });
    },
    handleReportClick(reportId) {
      // Close the sidebar when a report is clicked
      this.$emit('close');
      // Emit the selected report ID to parent
      this.$emit('report-selected', reportId);
    },
    loadReportGroups() {
      ReportService.getReportGroups().then((groups) => {
        this.localReportGroups = groups;
        const groupIndex = groups.map((g, i) =>
            g.reports.map(r => r.id).indexOf(this.currentReportId) >= 0 ? i : -1
        ).filter(i => i >= 0);

        if (groupIndex.length) {
          this.expandedGroups.set(groupIndex[0], true);
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    isExpanded(index) {
      return this.expandedGroups.get(index) === true;
    },
    toggleGroup(index) {
      this.expandedGroups.set(index, !this.isExpanded(index));
    },
  }
})
</script>
<style src="../assets/style.css"></style>
